/* eslint-disable no-param-reassign */
import Flickity from 'flickity-imagesloaded';

export default function gallerySlider() {
  const elementExists = document.querySelectorAll('.wp-block-gallery');
  if (typeof (elementExists) !== 'undefined' && elementExists !== null) {
    elementExists.forEach((slider) => {
      /**
       * WP 5.8 and 5.9 uses different HTML classes for the gallery block so we
       * need 2 different query selectors to support both cases.
       */
      const oldSlides = slider.querySelectorAll('.blocks-gallery-item'); // query selector for WP versions 5.8 or before
      const newSlides = slider.querySelectorAll('.wp-block-image'); // query selector for WP versions 5.9 or later

      // Make sure there are slides at all.
      if (oldSlides.length !== 0 || newSlides.length !== 0) {
        // eslint-disable-next-line no-unused-vars
        const flkty = new Flickity(slider, {
          contain: true,
          imagesLoaded: true,
          pageDots: false,
          // Set old selector as default but if gallery is in the new format, use new selector.
          cellSelector: newSlides.length !== 0 ? '.wp-block-image' : '.blocks-gallery-item',
          autoPlay: false,
          freeScroll: false,
          initialIndex: 0,
          wrapAround: true,
          adaptiveHeight: false,
        });

        const captions = slider.querySelectorAll('figcaption');
        let cellNumber = 1;
        if (typeof (captions) !== 'undefined' && captions !== null) {
          captions.forEach((caption) => {
            caption.innerHTML += `<span class="flickity-count">${cellNumber}/${flkty.slides.length}</span>`;
            cellNumber += 1;
          });
        }
      }
    });
  }
}
